import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./index.css";
import { ModernPortfolio } from "./projects/portfolio/ModernPortfolio";
import Experiments from "./projects/portfolio/Experiments";
import Hangman from "./projects/hangman/Hangman";
import WhosThatPokemon from "./projects/whos-that-pokemon/WhosThatPokemon";
import PokemonMemoryGame from "./projects/pokemon-memory-game/PokemonMemoryGame";
import Plotle from "./projects/plotle/Plotle";

import { configureAnalytics } from "./configure-analytics";
import FiftyStates from "./projects/fifty-states/FiftyStates";
import Hilo from "./projects/hilo/Hilo";
import ByTheNumbers from "./projects/by-the-numbers/ByTheNumbers";

configureAnalytics(window.location.hostname);

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<ModernPortfolio />} />
      
      {/* Individual game routes - kept for direct access but not prominently featured */}
      <Route path="/by-the-numbers" element={<ByTheNumbers />} />
      <Route path="/whos-that-pokemon" element={<WhosThatPokemon />} />
      <Route path="/plotle" element={<Plotle />} />
      <Route path="/hangman" element={<Hangman />} />
      <Route path="/pokemon-memory-game" element={<PokemonMemoryGame />} />
      <Route path="/50states" element={<FiftyStates />} />
      <Route path="/hilo" element={<Hilo />} />
      <Route path="/experiments" element={<Experiments />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </BrowserRouter>
);
